import { Theme } from 'config';

const styles = (theme: Theme) => ({
  textLabel: {
    fontSize: '1.1rem',
    marginRight: '.5rem',
    marginBottom: '0',
    fontWeight: 'bold',
  },
  spacer: {
    paddingRight: '1rem !important',
    paddingBottom: '.5rem !important',
  },
  listItems: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  centeredRow: {
    textAlign: 'center',
  },
  container: {
    padding: '0 !important',
    fontSize: '0.875rem !important',
    color: '#646464 !important',
    fontFamily: 'DOSH !important',
    fontWeight: 'normal !important',
  },
  download: {
    padding: '0 !important',
    background: 'transaparent',
  },
  pagination: {
    '& *': {
      fontSize: '.800rem !important',
    },

    minHeight: '0 !important',
  },
  table: {
    fontSize: '.900rem !important',
    padding: '0 !important',
  },
  tableHeader: {
    backgroundColor: '#ffffff !important',
    color: '#646464 !important',
    fontSize: '0.875rem !important',
    fontWeight: '400 !important',
    fontFamily: 'DOSH !important',
    border: 'none !important;',
    borderBottom: '0.0625rem solid rgba(34,36,38,.1) !important',
  },
  downloadCell: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  tableBody: {
    '& tr': {
      fontFamily: 'DOSH !important',
      fontSize: '0.850rem',
      color: '#646464 !important',
    },
    '& a': {
      color: '#4183c4 !important',
    },
  },
  supplementalRow: {
    border: '0 !important;',
    background: '#fafbfb',
  },
  selectedRow: {},
  segmentListItem: {
    backgroundColor: '#fff !important',
    borderRadius: '.375rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '1rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',

    '&.expired': {
      backgroundColor: `${theme.disabledBtnGray} !important`,
    },
  },
  ref: { width: '100%' },
  justifyLeft: {
    textAlign: 'left !important',
  },
  justifyRight: {
    textAlign: 'right !important',
  },
  justifyCenter: {
    textAlign: 'center !important',
  },
  expandableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  dateLabel: {
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
});

export default styles;
